// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_6TP","cls2":"Comments-cls2_RlI Comments-cls1_6TP"};